export const CloudIcon = ({ isBig = false }: { isBig?: boolean }) => {
  return (
    <svg
      width={isBig ? 48 : 27}
      height={isBig ? 48 : 21}
      viewBox="0 0 27 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.32"
        d="M22.6673 14C24.8767 14 26.6673 12.2093 26.6673 10C26.6673 7.79067 24.8767 6 22.6673 6H22.626C22.6527 5.78133 22.6673 5.55867 22.6673 5.33333C22.6673 2.388 20.2793 0 17.334 0C15.0007 0 13.0167 1.49867 12.294 3.58533C11.7807 3.42133 11.2353 3.33333 10.6673 3.33333C7.72198 3.33333 5.33398 5.72133 5.33398 8.66667C5.33398 11.612 7.72198 14 10.6673 14C11.1273 14 11.574 13.9413 12.0007 13.832V14H22.6673Z"
        fill="#73A5E6"
      />
      <path
        d="M5.33333 20.6667C2.388 20.6667 0 18.2787 0 15.3333C0 12.388 2.388 10 5.33333 10C5.88933 10 6.424 10.0853 6.928 10.2427C7.67867 7.78667 9.964 6 12.6667 6C15.98 6 18.6667 8.68667 18.6667 12C18.6667 12.3133 18.6427 12.62 18.596 12.92C19.0333 12.756 19.5053 12.6667 20 12.6667C22.2093 12.6667 24 14.4573 24 16.6667C24 18.876 22.2093 20.6667 20 20.6667H5.33333Z"
        fill="url(#paint0_linear_10271_118477)"
      />
      <path
        d="M6.66667 12C6.66667 15.3133 9.35333 18 12.6667 18C15.668 18 18.1533 15.7973 18.596 12.92C19.0333 12.756 19.5053 12.6667 20 12.6667C22.2093 12.6667 24 14.4573 24 16.6667C24 18.876 22.2093 20.6667 20 20.6667H5.33333C2.388 20.6667 0 18.2787 0 15.3333C0 12.388 2.388 10 5.33333 10C5.88933 10 6.424 10.0853 6.928 10.2427C6.75733 10.7987 6.66667 11.388 6.66667 12Z"
        fill="url(#paint1_radial_10271_118477)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10271_118477"
          x1="1200"
          y1="6"
          x2="1200"
          y2="1472.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9FC7FF" />
          <stop offset="1" stopColor="#9BC1F5" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_10271_118477"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(85.8526 -1340.5) rotate(-90) scale(1397.16 446.47)"
        >
          <stop stopColor="#486DA8" stopOpacity="0.4" />
          <stop offset="1" stopColor="#486DA8" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};
